<template>
  <div>
    <div class="tax-con">
      <div class="title">
        <img :src="titleImg">
        <p>请确认是否已完成税务数据授权</p>
      </div>
      <div class="infos">
        <p class="text1">税务数据授权方式</p>
        <p class="text2">
          请查看税务数据授权步骤，按照说明到相关页面进行授权，
          <span class=" default-color" @click="showContractPDF">点击查看税务数据授权步骤</span>
        </p>
      </div>
      <Button :text="text" :type="danger" :loading="isLoading" :disabled="isLoading" loadingText="提交中..." :class="isLoading ? 'next-gray' : 'next'" :click="onSubmit" />
      <standard-p-d-f
        :fileName="fileName"
        :fileKey="fileKey"
        v-model="isShowPopup"
      />
    </div>
  </div>
</template>

<script>
import StandardPDF from '@/components/StandardPDF.vue';
import Button from '@/components/Button.vue';
import { Toast } from 'vant';

export default {
  name: 'taxEmpower',
  components: {
    StandardPDF,
    Button
  },
  data() {
    return {
      titleImg: require('@/assets/images/waiting_ico.png'),
      text: '确认完成',
      danger: 'danger',
      isShowPopup: false,
      contractId: '',
      isLoading: false,
      fileName: '',
      fileKey: '',
    };
  },
  mounted() {
    this.enterpriseInfo();
  },
  methods: {
    showContractPDF() {
      this.isShowPopup = true;
    },
    // pdf信息 此页面pageId：7
    async enterpriseInfo() {
      try {
        const { data, success, returnMessage } = await this.$api.OtherPage.queryEchoInfo(
          {
            orderId: this.$route.query.orderId,
	          pageId: this.$route.query.pageId
          },
        );
        if (success) {
          this.fileName = data.fileName;
          this.fileKey = data.fileKey;
        } else {
          Toast(returnMessage);
        }
      } catch (e) {
        Toast('接口异常');
      }
    },
    onSubmit() {
      this.$dialog.confirm({
        title: '提示',
        message: '税务数据授权是获取增信，提高授信额度的重要手段。确认已完成？',
        confirmButtonText: '确认',
        cancelButtonText: '取消',
      }).then(() => {
        this.isLoading = true;
        (async () => {
            try {
            const { success, returnMessage } = await this.$api.OtherPage.commitApply(
              {
                orderId: this.$route.query.orderId,
                pageId: this.$route.query.pageId
              },
            );
            if (success) {
              this.$store.dispatch('otherPages/jumpCurrPageServer');
            } else {
              this.isLoading = false;
              Toast(returnMessage);
            }
          } catch (e) {
            this.isLoading = false;
            Toast('接口异常');
          }
        })()
      })
    },
  },
};
</script>
<style scoped>
.tax-con {
  height: 100vh;
  background: #fff;
}
.tax-con .title {
  text-align: center;
  padding: 80px 0 50px 0;
  font-size: 18px;
  font-weight: bold;
}
.tax-con .title img {
  width: 60px;
  margin-bottom: 16px;
}
.tax-con p {
  color: #1C2438;
  line-height: 18px;
  margin: 0;
}
.tax-con .text1 {
  font-size: 16px;
  font-weight: bold;
  color: #2F3133;
  margin: 10px 0;
}
.tax-con .text2 {
  font-size: 12px;
  color: #7C7C7C;
}
.tax-con .default-color {
  color: #ff6538;
}
.infos {
  text-align: left;
  padding: 14px 16px 20px 16px;
  background: #F5F5F5;
}
.next >>> .van-button {
  box-shadow: 0px 12px 12px -10px #ff6538;
  border: 0;
  margin-top: 20px;
  transition: 0.7s;
}

.next-gray >>> .van-button {
  box-shadow: 0px 12px 12px -10px #7691a3;
  border: 0;
  margin-top: 20px;
  transition: 0.7s;
}
</style>
